import { render } from "./SamplingPointImageModal.component.vue?vue&type=template&id=32649454&scoped=true&ts=true"
import script from "./SamplingPointImageModal.component.vue?vue&type=script&lang=ts"
export * from "./SamplingPointImageModal.component.vue?vue&type=script&lang=ts"

import "./SamplingPointImageModal.component.vue?vue&type=style&index=0&id=32649454&lang=css"
import "./SamplingPointImageModal.component.vue?vue&type=style&index=1&id=32649454&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/WEAS/WEAS_CI/WEAS_FRONT/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32649454"]])

export default __exports__